export const MainMenuList = {
  label: "Main Menu",
  children: [
    {
      name: "Planificación",
      icon: "timeline",
      to: "/planification",
      //allowedRoles: [GENERAL_USER, ADMIN_USER],
      active: true,
    },
    {
      name: "Reglas",
      icon: "pen-ruler",
      to: "/rules",
      //allowedRoles: [ADMIN_USER],
      active: true,
    },
    {
      name: "Configuración de propiedad",
      icon: "door-open",
      to: "/property",
      //allowedRoles: [ADMIN_USER],
      active: true,
    },
    {
      name: "Inventario",
      icon: "boxes-stacked",
      to: "/inventory",
      //allowedRoles: [ADMIN_USER],
      active: true,
    },
    {
      name: "Bloqueos",
      icon: "ban",
      to: "/blocks",
      //allowedRoles: [ADMIN_USER],
      active: true,
    },
    {
      name: "INE",
      icon: "globe",
      to: "/ine",
      //allowedRoles: [ADMIN_USER],
      active: true,
    },
    {
      name: "Invoicing",
      icon: "file-invoice-dollar",
      to: "/invoicing",
      //allowedRoles: [ADMIN_USER],
      active: true,
    },
    {
      name: "Ajustes",
      icon: "gear",
      to: "/settings",
      //allowedRoles: [ADMIN_USER],
      active: true,
    },
  ],
};

export const AdminMenuList = {
  label: "Admin Menu",
  children: [
    {
      name: "Propiedades",
      icon: "timeline",
      to: "/admin/properties",
      //allowedRoles: [GENERAL_USER, ADMIN_USER],
      active: true,
    },
    {
      name: "Usuarios",
      icon: "users",
      to: "/admin/users",
      //allowedRoles: [ADMIN_USER],
      active: true,
    },
    {
      name: "Roles y Permisos",
      icon: "users-gear",
      to: "/admin/roles",
      //allowedRoles: [ADMIN_USER],
      active: true,
    },
    {
      name: "Países y provincias INE",
      icon: "globe",
      to: "/admin/ine/countries",
      //allowedRoles: [ADMIN_USER],
      active: true,
    },
  ],
};

export default [MainMenuList];
